import ThreeDotsMoreIcon from './ThreeDotsMoreIcon';

export default ThreeDotsMoreIcon;
